import React from 'react';

import POSScreenSwitcher from './POSScreenSwitcher';

const POSApplication = () => {
  return <POSScreenSwitcher />;
};

export default POSApplication;
